import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, withModifiers as _withModifiers } from "vue"
import _imports_0 from '../../assets/Images/img-realtor-tolls.png'
import _imports_1 from '../../assets/Images/logo-login.png'


const _hoisted_1 = { class: "log-in" }
const _hoisted_2 = { class: "container-fixed" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "visible-mobile" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "log-in__content__imagen" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: ""
    })
  ])
], -1)
const _hoisted_4 = { class: "log-in__content d-flex justify-content-between align-items-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "hidden-mobile" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "log-in__content__imagen" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: ""
    })
  ])
], -1)
const _hoisted_6 = { class: "log-in__content__formulario w-50 d-flex justify-content-center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "log-in__content__formulario__img tw-flex tw-justify-center" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "/" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "img-login",
      src: _imports_1,
      alt: ""
    })
  ])
], -1)
const _hoisted_8 = { href: "/" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  key: 0,
  class: "d-block mb-5"
}
const _hoisted_12 = {
  key: 1,
  class: "d-block mb-5"
}
const _hoisted_13 = {
  key: 2,
  class: "d-block mb-5"
}
const _hoisted_14 = {
  key: 3,
  class: "form-group"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user" }, null, -1)
const _hoisted_16 = {
  key: 4,
  class: "form-group"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-lock" }, null, -1)
const _hoisted_18 = ["type"]
const _hoisted_19 = {
  key: 5,
  class: "form-group"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-lock" }, null, -1)
const _hoisted_21 = {
  key: 6,
  class: "form-group"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-lock" }, null, -1)
const _hoisted_23 = ["type"]
const _hoisted_24 = { class: "form-check" }
const _hoisted_25 = ["disabled"]
const _hoisted_26 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("form", {
            onSubmit: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"]))
          }, [
            _hoisted_7,
            _createElementVNode("div", {
              class: _normalizeClass(["log-in__content__formulario__tittle", { 'tw-mb-0': _ctx.forgotPassword }])
            }, [
              _createElementVNode("a", _hoisted_8, [
                (!_ctx.forgotPassword)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, "Log In"))
                  : _createCommentVNode("", true),
                (_ctx.forgotPassword)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, "Reset your password"))
                  : _createCommentVNode("", true)
              ])
            ], 2),
            (_ctx.forgotPassword && !_ctx.sendedCode)
              ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Enter your email to reset your password"))
              : _createCommentVNode("", true),
            (_ctx.forgotPassword && _ctx.sendedCode && !_ctx.forgotForm.code)
              ? (_openBlock(), _createElementBlock("span", _hoisted_12, "Enter your code to reset your password"))
              : _createCommentVNode("", true),
            (_ctx.forgotPassword && _ctx.sendedCode && _ctx.forgotForm.code)
              ? (_openBlock(), _createElementBlock("span", _hoisted_13, "Enter your new password"))
              : _createCommentVNode("", true),
            (!_ctx.forgotPassword && !_ctx.sendedCode || _ctx.forgotPassword && !_ctx.sendedCode)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _hoisted_15,
                  _withDirectives(_createElementVNode("input", {
                    type: "email",
                    class: _normalizeClass(["form-control", { 'is-invalid': _ctx.v$.loginForm.email.$invalid, 'is-valid': !_ctx.v$.loginForm.email.$invalid }]),
                    id: "exampleInputEmail1",
                    "aria-describedby": "emailHelp",
                    placeholder: "Enter email",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.v$.loginForm.$model.email) = $event))
                  }, null, 2), [
                    [_vModelText, _ctx.v$.loginForm.$model.email]
                  ])
                ]))
              : _createCommentVNode("", true),
            (!_ctx.forgotPassword)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _hoisted_17,
                  _withDirectives(_createElementVNode("input", {
                    type: _ctx.v$.loginForm.password.show ? 'text':'password',
                    class: _normalizeClass(["form-control", { 'is-invalid': _ctx.v$.loginForm.password.$invalid, 'is-valid': !_ctx.v$.loginForm.password.$invalid }]),
                    id: "exampleInputPassword1",
                    placeholder: "Password",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.v$.loginForm.$model.password) = $event))
                  }, null, 10, _hoisted_18), [
                    [_vModelDynamic, _ctx.v$.loginForm.$model.password]
                  ]),
                  (!_ctx.v$.loginForm.password.show)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "tw-absolute tw-right-[35px] tw-top-1/2 -tw-translate-y-1/2 tw-text-[#339366] tw-hover:bg-blue-700 tw-font-bold tw-py-1 tw-px-4 tw-rounded",
                        type: "button",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.v$.loginForm.password.show = true))
                      }, "show"))
                    : _createCommentVNode("", true),
                  (_ctx.v$.loginForm.password.show)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: "tw-absolute tw-right-[35px] tw-top-1/2 -tw-translate-y-1/2 tw-text-red-500 tw-hover:bg-blue-700 tw-font-bold tw-py-1 tw-px-4 tw-rounded",
                        type: "button",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.v$.loginForm.password.show = false))
                      }, "hide"))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.forgotPassword && _ctx.sendedCode)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _hoisted_20,
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    class: _normalizeClass(["form-control", { 'is-invalid': _ctx.v$.forgotForm.code.$invalid, 'is-valid': !_ctx.v$.forgotForm.code.$invalid }]),
                    id: "exampleInputPassword1",
                    placeholder: "Your code",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.forgotForm.code) = $event))
                  }, null, 2), [
                    [_vModelText, _ctx.forgotForm.code]
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.forgotPassword && _ctx.sendedCode && _ctx.forgotForm.code)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _hoisted_22,
                  _withDirectives(_createElementVNode("input", {
                    type: _ctx.v$.forgotForm.newpassword.show ? 'text':'password',
                    class: _normalizeClass(["form-control", { 'is-invalid': _ctx.v$.forgotForm.newpassword.$invalid, 'is-valid': !_ctx.v$.forgotForm.newpassword.$invalid }]),
                    id: "exampleInputPassword1",
                    placeholder: "Your new password",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.forgotForm.newpassword) = $event))
                  }, null, 10, _hoisted_23), [
                    [_vModelDynamic, _ctx.forgotForm.newpassword]
                  ]),
                  (!_ctx.v$.forgotForm.newpassword.show)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "tw-absolute tw-right-[35px] tw-top-1/2 -tw-translate-y-1/2 tw-text-[#339366] tw-hover:bg-blue-700 tw-font-bold tw-py-1 tw-px-4 tw-rounded",
                        type: "button",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.v$.forgotForm.newpassword.show = true))
                      }, "show"))
                    : _createCommentVNode("", true),
                  (_ctx.v$.forgotForm.newpassword.show)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: "tw-absolute tw-right-[35px] tw-top-1/2 -tw-translate-y-1/2 tw-text-red-500 tw-hover:bg-blue-700 tw-font-bold tw-py-1 tw-px-4 tw-rounded",
                        type: "button",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.v$.forgotForm.newpassword.show = false))
                      }, "hide"))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (!_ctx.forgotPassword)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 7,
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.forgotPassword = true))
                }, "Forgot password ?"))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_24, [
              (!_ctx.forgotPassword)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "submit",
                    class: "btn btn-primary mt-3 mb-4",
                    disabled: !_ctx.submitButton
                  }, "Log In", 8, _hoisted_25))
                : _createCommentVNode("", true),
              (_ctx.forgotPassword)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    type: "submit",
                    class: "btn btn-primary mt-3 mb-4",
                    disabled: !_ctx.submitButton
                  }, "Reset Password", 8, _hoisted_26))
                : _createCommentVNode("", true)
            ]),
            (_ctx.forgotPassword)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 8,
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.forgotPassword = false))
                }, "Back"))
              : _createCommentVNode("", true)
          ], 32)
        ])
      ])
    ])
  ]))
}